import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgForm } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtListeDocumentComponent } from '../avt-liste-document/avt-liste-document.component';
import { RechercheComponent } from '../recherche/recherche.component';
import { EditorComponent } from '../editor/editor.component';
import * as globalUrls from '../services/globalVariables';
declare var $: any;
@Component({
  selector: 'app-avt-document',
  templateUrl: './avt-document.component.html',
  styleUrls: ['./avt-document.component.scss'],
})
export class AvtDocumentComponent implements OnInit {
  constructor(
    public router: Router,
    public generalService: GeneralService,
    public route: ActivatedRoute
  ) {}

  // facture          fenetre == "1"
  // commande         fenetre == "2"
  // dvis             fenetre == "3"
  // bon de livraison fenetre == "4"
  fenetre: string;
  param_code: string;
  typeTrs: string;
  exist: boolean = true;
  nomFenetre: string = 'FACTURE';
  document;
  doc;
  documentD;
  ApiParam = [{ androidId: 123 }];
  listeDevise;
  tiers;
  tiersEntiteFacturation;
  disabled = false;
  showInformationsInPrint: boolean;
  showPaysInPrint: boolean;
  showTVAInPrint: boolean;
  nameBtn = '';
  listBtnDocumentD: Array<any> = [
    {
      name: 'ajouterLigneDocumentD',
      class: 'colorBlue',
      text: 'Ajouter',
      icon: 'add',
      disabled: false,
    },
    {
      name: 'supprimerLigneDocumentD',
      class: 'colorRed',
      text: 'Supprimer',
      icon: 'delete',
      disabled: false,
    },
  ];
  @ViewChild('frmInformationclient', { static: true })
  frmInformationclient: NgForm;
  @ViewChild('frmEntetDocument', { static: true }) frmEntetDocument: NgForm;
  // @ViewChild("listeArticleComponen", {static : false}) listeArticleComponen : AvtListesComponent;
  @ViewChild('documentDComponen', { static: false })
  documentDComponen: AvtListesComponent;
  @ViewChild('listeMontantsSupplementairesComponen', { static: false })
  listeMontantsSupplementairesComponen: AvtListesComponent;

  columnsListeMontantsSupplementaires = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'intitule',
        Lg_Code: '',
        TableRD_Des: 'Intitulé',
        TableRD_Largeur: 400,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'montant',
        Lg_Code: '',
        TableRD_Des: 'Montant',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        numColonneToShow: 1,
        numColonneToReturn: 0,
        recherche: 'ecarticleauto',
        param: '',
        required: true,
        style: { width: '400px' },
        placeholder: 'Article',
      },
    ],
  };
  listBtnListeArticle: Array<any> = [
    {
      name: 'addRow',
      class: 'colorBlue',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'deleteRow',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];
  InformationsBasPages: string;
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = this.generalService.clone(this.generalService.editorConfig);
  documentSansRepance: boolean = false;
  index: number = 0;
  listeModePaiement = [];
  listeModeFacturation = [];
  gestionEcritureComtable: string;
  showGestionEcritureComtable: boolean = false;
  showDoc_ExoDateFin: boolean = false;
  showDoc_DateAvisExped: boolean = false;
  showDateRelance: boolean = false;
  showDoc_ExoDate: boolean = false;
  showDoc_DateP: boolean = false;
  showDoc_DateRelance1: boolean = false;
  showDoc_DateRelance2: boolean = false;
  showDoc_DateRelance3: boolean = false;
  columnsNewDocument = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocD_Q',
        Lg_Code: '',
        TableRD_Des: 'Qté',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 2,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocD_Unite',
        Lg_Code: '',
        TableRD_Des: 'Unité',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Art_Des',
        Lg_Code: '',
        TableRD_Des: 'Désignation',
        TableRD_Largeur: 400,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocD_TVACode',
        Lg_Code: '',
        TableRD_Des: 'Taxe',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocD_PUHTB',
        Lg_Code: '',
        TableRD_Des: 'Prix.HT',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 2,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DocD_THT',
        Lg_Code: '',
        TableRD_Des: 'Total.HT',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 2,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
    customFooter: {
      listeFooter: [
        {
          colonne: [
            {
              text: 'Total HT ',
              style: { 'text-align': 'right', 'font-weight': 'bold' },
              colspan: 5,
            },
            {
              text: 0,
              style: { 'text-align': 'right', 'font-weight': 'bold' },
              colspan: 1,
            },
          ],
        },
        {
          colonne: [
            {
              text: 'TVA ',
              style: { 'text-align': 'right', 'font-weight': 'bold' },
              colspan: 5,
            },
            {
              text: 0,
              style: { 'text-align': 'right', 'font-weight': 'bold' },
              colspan: 1,
            },
          ],
        },
        {
          colonne: [
            {
              text: 'Total TTC ',
              style: { 'text-align': 'right', 'font-weight': 'bold' },
              colspan: 5,
            },
            {
              text: 0,
              style: { 'text-align': 'right', 'font-weight': 'bold' },
              colspan: 1,
            },
          ],
        },
      ],
    },
  };
  listeTva = [];
  newRowDocumentD = {
    DocD_Id: '',
    Art_Code: '001',
    Art_Des: '',
    DocD_Q: '',
    DocD_QReliquat: 0,
    DocD_Unite: '',
    DocD_TVACode: '',
    DocD_PUHTB: 0,
    DocD_THT: 0,
    Doc_Num: '',
  };
  mode: string;
  Tiers_code: string;
  indexTabs: number;
  modeFacturation: number;
  modePaiement: number;
  tva: number;
  @ViewChild('clientComponent', { static: false })
  clientComponent: RechercheComponent;
  Doc_Type: string;
  avtAction_Code: string;
  initDoc;
  @ViewChild('editorInfoBasPage', { static: false })
  editorInfoBasPage: EditorComponent;
  @ViewChild('editorCommentaires', { static: false })
  editorCommentaires: EditorComponent;
  showEditorInfoBasPage: boolean = false;
  showEditorCommentaires: boolean = false;
  configCommentaires = { height: 50 };
  configInfoBasPage = { height: 50 };
  factureAvoir;
  ngOnInit() {
    this.document = {};
    // Angular Editor Supprimer
    // this.editorConfig.height = "200px"
    this.exist = false;
    this.tiersEntiteFacturation = {};
    this.tiers = {};
    this.getDevise();
    this.getListeTva();
    this.getListeModePaiement();
    this.getListeModeFacturation();
    this.readParamUrl();
  }
  outputActionNewDocument(event) {
    if (event.event.keyCode == 9)
      if (event.index == this.documentDComponen.dataSource.data.length - 1) {
        var c =
          this.columnsNewDocument.TableRD[
            this.columnsNewDocument.TableRD.length - 2
          ].TableRD_Champs;
        if (event.column.TableRD_Champs == c) this.addNewRowInDocument();
      }
    this.calculerDevis();
  }
  onTvaChange() {
    // var data = this.newDocumentComponen.dataSource.data;
    // var selectedTva = this.listeTva.find(tva =>{return tva.DiverSys_Index == this.tva})
    // data.forEach(row =>
    // {
    //     row.DocD_TVACode = selectedTva.DiverSys_Titre;
    // });
    // this.calculerDevis()
  }
  getListeTva() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM01')
      .subscribe((data) => {
        this.listeTva = data.DiverSys;
        this.listeTva.forEach((tva) => {
          tva.DiverSys_Index = tva.DiverSys_Index.toString();
        });
        this.columnsNewDocument.TableRD[3].dataSelect = this.listeTva;
      });
  }
  calculerDevis() {
    var data = this.documentDComponen.dataSource.data;
    this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text = 0;
    data.forEach((row) => {
      if (
        this.generalService.isNotEmpty(row.DocD_Q) &&
        this.generalService.isNotEmpty(row.DocD_PUHTB)
      )
        row.DocD_THT = row.DocD_Q * row.DocD_PUHTB;
      if (this.generalService.isNotEmpty(row.DocD_TVACode)) {
        var selectedTva = this.listeTva.find((tva) => {
          return tva.DiverSys_Index == row.DocD_TVACode;
        });
        if (selectedTva) {
          var tva = parseInt(selectedTva.DiverSys_Titre.replace('%', '')) / 100;
          var THT = row.DocD_THT * tva;
          var somme = parseInt(
            this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text.toString()
          );
          this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text =
            somme + THT;
        }
      }
    });
    this.columnsNewDocument.customFooter.listeFooter[0].colonne[1].text = data
      .map((row) => row.DocD_THT)
      .reduce((acc, value) => acc + value, 0);
    // if(this.generalService.isNotEmpty(this.tva))
    // {
    //   var selectedTva = this.listeTva.find(tva =>{return tva.DiverSys_Index == this.tva})
    //   var tva = parseInt(selectedTva.DiverSys_Titre.replace("%",""))/100
    //   this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text = data.map(row => row.DocD_THT).reduce((acc, value) => acc + value*tva, 0);
    // }
    var THT = parseInt(
      this.columnsNewDocument.customFooter.listeFooter[0].colonne[1].text.toString()
    );
    var TTVA = parseInt(
      this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text.toString()
    );
    this.columnsNewDocument.customFooter.listeFooter[2].colonne[1].text =
      THT + TTVA;
  }
  addNewRowInDocument() {
    if (this.newRowDocumentD) {
      var data = this.documentDComponen.dataSource.data;
      data.push(this.getNewRowDocumentD());
      this.documentDComponen.setDataSource(data);
    }
  }

  getNewRowDocumentD(setDoc_Num: Boolean = true) {
    var row = JSON.parse(JSON.stringify(this.newRowDocumentD));
    var selectedTva = this.listeTva.find((tva) => {
      return tva.DiverSys_Index == this.tva;
    });
    row.DocD_TVACode = selectedTva ? selectedTva.DiverSys_Index : '';
    if (setDoc_Num) row.Doc_Num = this.document.Doc_Num;
    row.Art_Code = '001';
    return row;
  }
  getDevise() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=DOCUMENT01')
      .subscribe((data) => {
        this.listeDevise = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.exist = true;
      });
  }
  init() {
    this.disabled = this.typeTrs == '3' ? true : false;
    this.listBtnDocumentD.forEach((btn) => {
      btn.disabled = this.typeTrs == '3' ? true : false;
    });
    this.setNomDoc();
    this.getDocument();
    if (this.mode == 'modal') {
      this.index = this.indexTabs;
    } else this.index = 0;
  }
  getUrl() {
    var url = 'ds/formdata?code=document';
    if (this.typeTrs != '1') url += '&val=' + this.param_code;
    return url;
  }
  animationDone() {
    if (this.index == 2) {
      this.showEditorInfoBasPage = true;
      setTimeout(() => {
        this.editorInfoBasPage.setHTML(this.document.Doc_Param1);
      }, 100);
    }
    if (this.index == 3) {
      this.showEditorCommentaires = true;
      setTimeout(() => {
        this.editorCommentaires.setHTML(this.document.Doc_Adresse2);
      }, 100);
    }
  }
  setTchekBox() {
    if (this.document.Doc_ExoDateFin) this.showDoc_ExoDateFin = true;
    else this.showDoc_ExoDateFin = false;
    if (this.document.Doc_DateAvisExped) this.showDoc_DateAvisExped = true;
    else this.showDoc_DateAvisExped = false;
    if (this.document.Doc_DateRelance) this.showDateRelance = true;
    else this.showDateRelance = false;
    if (this.document.Doc_ExoDate) this.showDoc_ExoDate = true;
    else this.showDoc_ExoDate = false;
    if (this.document.Doc_DateP) this.showDoc_DateP = true;
    else this.showDoc_DateP = false;
    if (this.document.Doc_DateRelance1) this.showDoc_DateRelance1 = true;
    else this.showDoc_DateRelance1 = false;
    if (this.document.Doc_DateRelance2) this.showDoc_DateRelance2 = true;
    else this.showDoc_DateRelance2 = false;
    if (this.document.Doc_DateRelance3) this.showDoc_DateRelance3 = true;
    else this.showDoc_DateRelance3 = false;
  }
  getDocument() {
    var url = this.getUrl();
    this.generalService.rechercheTable(url).subscribe((doc) => {
      doc.DocumentD = doc.DocumentD.filter((d) => {
        return this.generalService.isNotEmpty(d.DocD_Id);
      });
      doc.DocumentD.forEach((docD) => {
        if (this.generalService.isEmpty(docD.Art_Code)) docD.Art_Code = '001';
      });
      this.doc = doc;
      this.document = this.doc.Document[0];
      this.documentD = this.doc.DocumentD;
      this.setTchekBox();
      if (this.mode == 'modal') {
        this.document.Doc_ModeReg = this.modePaiement;
        // this.document.ModeFac_Code = this.modeFacturation
      }
      if (this.typeTrs != '1') {
        this.documentDComponen.setDataSource(
          JSON.parse(JSON.stringify(this.documentD))
        );
        this.calculerDevis();
      }
      if (this.mode == 'ordinaire') {
        if (this.typeTrs != '1') this.getTiers(this.document.Tiers_code);
      } else if (this.generalService.isNotEmpty(this.Tiers_code))
        this.getTiers(this.Tiers_code);
    });
  }
  getClient() {
    this.generalService
      .rechercheTable(globalUrls.urlClient)
      .subscribe((client) => {});
  }
  setNomDoc() {
    //facture fenetre == "1"
    if (this.fenetre == '1') {
      this.nomFenetre = 'facture';
      this.nameBtn = 'factures';
      this.Doc_Type = 'FACT';
    }
    if (this.fenetre == '2') {
      this.nomFenetre = 'bon de commande';
      this.nameBtn = 'bons de commande';
      this.Doc_Type = 'CMD';
    }
    if (this.fenetre == '3') {
      this.nomFenetre = 'devis';
      this.nameBtn = 'devis';
      this.Doc_Type = 'FACP';
    }
    if (this.fenetre == '4') {
      this.nomFenetre = 'bon de livraison';
      this.nameBtn = 'bons de livraison';
      this.Doc_Type = 'BLC';
    }
    if (this.fenetre == '5') {
      this.nomFenetre = 'avoir';
      this.nameBtn = 'avoir';
      this.Doc_Type = 'AVC';
    }
  }
  attacherDocument() {
    var random = Math.random().toString().substr(2, 5);
    var windows = this.generalService.popupCenter(
      '/w/avt/liste/document/1/modal/' + random
    );
    windows.onbeforeunload = () => {
      var srtDocument = localStorage.getItem(random);
      if (srtDocument) {
        this.exist = false;
        localStorage.removeItem(random);
        var factureAvoir = JSON.parse(srtDocument);
        this.generalService
          .rechercheTable(
            'ds/formdata?code=document&val=' + factureAvoir.Doc_Num
          )
          .subscribe((doc) => {
            doc.DocumentD = doc.DocumentD.filter((d) => {
              return this.generalService.isNotEmpty(d.DocD_Id);
            });
            doc.DocumentD.forEach((docD) => {
              if (this.generalService.isEmpty(docD.Art_Code))
                docD.Art_Code = '001';
            });
            this.factureAvoir = doc;
            var DocumentD = [];
            this.factureAvoir.DocumentD.forEach((docD) => {
              var row = this.getNewRowDocumentD(false);
              row.Art_Code = docD.Art_Code;
              row.Art_Des = docD.Art_Des;
              row.DocD_Q = docD.DocD_Q;
              row.DocD_Unite = docD.DocD_Unite;
              row.DocD_TVACode = docD.DocD_TVACode;
              row.DocD_PUHTB = docD.DocD_PUHTB;
              row.DocD_THT = docD.DocD_THT;
              DocumentD.push(JSON.parse(JSON.stringify(row)));
            });
            this.documentDComponen.setDataSource(DocumentD);
            this.documentD = this.factureAvoir.DocumentD;
            this.clientComponent.parentVal =
              this.factureAvoir.Document[0].Tiers_code;
            this.clientComponent.valueColonneToReturn =
              this.factureAvoir.Document[0].Doc_RS;
            this.generalService
              .rechercheTable(
                globalUrls.urlClient + '&val=' + this.clientComponent.parentVal
              )
              .subscribe((data) => {
                this.tiersEntiteFacturation = data.Tiers[0];
                this.exist = true;
                $('#sendBtn').trigger('click');
              });
          });
      }
    };
  }
  blurTiers(Tiers_code) {
    this.exist = false;
    this.document.Tiers_code = Tiers_code;
    this.getTiers(Tiers_code);
  }
  getTiers(Tiers_code) {
    this.exist = false;
    this.generalService
      .rechercheTable(globalUrls.urlClient + '&val=' + Tiers_code)
      .subscribe(
        (data) => {
          this.tiers = data.Tiers[0];
          this.clientComponent.parentVal = this.tiers.Tiers_NomPublic;
          this.clientComponent.valueColonneToReturn = Tiers_code;
          this.getEntiteDeFacturation(this.tiers.Tiers_codeF);
          this.exist = true;
        },
        () => {
          this.exist = true;
        }
      );
  }
  clearTiers() {
    this.tiers = {};
    this.tiersEntiteFacturation = {};
  }
  getEntiteDeFacturation(Tiers_codeF) {
    if (this.generalService.isNotEmpty(this.tiers.Tiers_codeF)) {
      this.generalService
        .rechercheTable(globalUrls.urlClient + '&val=' + Tiers_codeF)
        .subscribe((data) => {
          this.tiersEntiteFacturation = data.Tiers[0];
        });
    } else {
      this.tiersEntiteFacturation = this.generalService.clone(this.tiers);
    }
  }

  ChampBlur(event) {
    // console.log("ChampBlur")
    // console.log(event)
  }

  deleteRow(indexRow) {
    var listeArticle = this.documentDComponen.dataSource.data;
    var newListeArticle = [];
    for (var i = 0; i < listeArticle.length; i++) {
      if (i != indexRow) newListeArticle.push(listeArticle[i]);
    }
    this.documentDComponen.setDataSource(newListeArticle);
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'ajouterLigneDocumentD': {
        this.addNewRowInDocument();
        break;
      }
      case 'supprimerLigneDocumentD': {
        this.deleteRow(event.index);
        break;
      }
    }
  }
  // editeAction(event)
  // {
  //   this.generalService.actionChoisie = "";
  //   this.generalService.fenetreTypeAction = "0";
  //   var dialogRef = this.generalService.dialog.open(ActionPrestationComponent, new MatDialogConfig());

  //   dialogRef.afterClosed().subscribe(() =>
  //   {

  //     if( this.generalService.isNotEmpty( this.generalService.actionChoisie))
  //     {
  //         event.data[event.index].Art_Des = this.generalService.actionChoisie.avtAction_Intitule;
  //         this.listeArticleComponen.setDataSource(event.data);
  //     }
  //   });
  // }
  clickBtnHeatMontantsSupplementaires(event) {
    switch (event.name) {
      case 'addRow': {
        this.addNewRowInMontantsSupplementaires();
        break;
      }
      case 'deleteRow': {
        this.deleteRowMontantsSupplementaires(event.index);
        break;
      }
    }
  }
  addNewRowInMontantsSupplementaires() {
    //intitule montant
    var newRow = [{ intitule: '', montant: 0 }];
    var data = this.listeMontantsSupplementairesComponen.dataSource.data;
    data.push(newRow);
    this.listeMontantsSupplementairesComponen.setDataSource(data);
  }
  deleteRowMontantsSupplementaires(indexRow) {
    var listeMontantsSupplementaires =
      this.listeMontantsSupplementairesComponen.dataSource.data;
    var newListeMontantsSupplementaires = [];
    for (var i = 0; i < listeMontantsSupplementaires.length; i++) {
      if (i != indexRow)
        newListeMontantsSupplementaires.push(listeMontantsSupplementaires[i]);
    }
    this.listeMontantsSupplementairesComponen.setDataSource(
      newListeMontantsSupplementaires
    );
  }
  getListeModePaiement() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM04')
      .subscribe((data) => {
        this.listeModePaiement = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getListeModeFacturation() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM02')
      .subscribe((data) => {
        this.listeModeFacturation = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  goToListeDocument() {
    this.generalService.rowChoisie = '';
    this.generalService.fenetreAvtListeDocument = this.fenetre;
    this.generalService.dialogOpend = this.generalService.dialog.open(
      AvtListeDocumentComponent,
      new MatDialogConfig()
    );
    this.exist = false;
    this.generalService.dialogOpend.afterClosed().subscribe(() => {
      if (this.generalService.isNotEmpty(this.generalService.rowChoisie)) {
        this.param_code = this.generalService.rowChoisie.P_Num
          ? this.generalService.rowChoisie.P_Num
          : this.generalService.rowChoisie.Doc_Num;
        this.init();
      }
      this.exist = true;
    });
  }
  enregistrer() {
    if (
      this.frmEntetDocument.valid &&
      this.generalService.isNotEmpty(this.clientComponent.valueColonneToReturn)
    ) {
      this.exist = false;
      // Doc_Devise_Cours : taux de change
      if (this.typeTrs == '1') this.ajouterDocument();
      if (this.typeTrs == '2') this.modifierDocument();
    } else $('#sendBtn').trigger('click');
  }
  modifierDocument() {
    if (
      this.editorInfoBasPage &&
      this.generalService.isNotEmpty(this.editorInfoBasPage.getHTML())
    )
      this.document.Doc_Param1 = this.editorInfoBasPage.getHTML();
    if (
      this.editorCommentaires &&
      this.generalService.isNotEmpty(this.editorCommentaires.getHTML())
    )
      this.document.Doc_Adresse2 = this.editorCommentaires.getHTML();
    var DocumentD = JSON.parse(
      JSON.stringify(this.documentDComponen.dataSource.data)
    );
    this.documentD.forEach((docD) => {
      var d = DocumentD.find((dc) => {
        return dc.DocD_Id == docD.DocD_Id;
      });
      if (d == undefined) {
        docD.DocD_Q = 0;
        DocumentD.push(docD);
      }
    });
    var ds = {
      Document: [this.document],
      DocumentD: DocumentD,
      ApiParam: [{ androidId: 123 }],
    };
    this.save(ds);
  }
  ajouterDocument() {
    var document = [];
    if (this.documentDComponen.dataSource.data.length == 0) var documentD = [];
    else documentD = this.documentDComponen.dataSource.data;
    var ds;
    document.push({
      Devise_Code: 'TND',
      Doc_Devise_Cours: 1,
      Doc_Obs: this.document.Doc_Obs,
      Doc_Date: this.document.Doc_Date,
      Doc_THT:
        this.columnsNewDocument.customFooter.listeFooter[0].colonne[1].text,
      Doc_Num: '',
      Doc_Type: this.Doc_Type,
      Tiers_code: this.clientComponent.valueColonneToReturn,
      Doc_RS: this.tiersEntiteFacturation.Tiers_RS,
    });

    ds = { Document: document, DocumentD: documentD, ApiParam: this.ApiParam };
    console.log(ds);
    this.save(ds);
  }
  //ne pas supprimer
  doNotThink() {
    console.log('doNotThink');
  }
  supprimerLigneVideDocumentD(ds) {
    for (var i = 0; i < ds.DocumentD.length; i++) {
      if (
        this.generalService.isEmpty(ds.DocumentD[i].Art_Des) &&
        this.generalService.isEmpty(ds.DocumentD[i].DocD_Q)
      )
        ds.DocumentD.splice(i, 1);
    }
    return ds;
  }
  // pour corriger le bug d'avois Total hor tax = 0
  reEnregistrer() {
    this.generalService
      .rechercheTable('ds/formdata?code=document&val=' + this.param_code)
      .subscribe((doc) => {
        var Document = doc.Document;
        var DocumentD = doc.DocumentD;
        var ds = {
          Document: Document,
          DocumentD: DocumentD,
          ApiParam: [{ androidId: 123 }],
        };
        this.save(ds);
      });
  }
  save(ds) {
    if (this.mode == 'modal') {
      ds.Document[0].avtAction_Code = this.avtAction_Code;
    }
    this.generalService.saveDA(this.supprimerLigneVideDocumentD(ds)).subscribe(
      (data) => {
        this.param_code = data[0].Num;
        if (this.typeTrs == '1') {
          this.typeTrs = '2';
          this.reEnregistrer();
        } else {
          this.typeTrs = '2';
          this.getDocument();
          this.generalService.dialogSuccess('Enregistré', true);
        }
      },
      () => {
        this.exist = true;
        this.generalService.dialogSuccess('Non enregistré', false);
      }
    );
  }
  // enregistrerDocumentAction()
  // {
  //   this.generalService.rechercheTable(this.generalService.urlAction+"&val="+this.avtAction_Code).subscribe(myAction =>
  //   {
  //     myAction.avtactionDoc = []
  //     myAction.avtactionDoc.push({Doc_Num: this.param_code, U_timestamp: null, avtAction_Code : this.avtAction_Code})
  //     this.generalService.enregisterTable(this.generalService.supprimerTableVideAction(myAction,["avtActionReferent","avtActionType","avtActionTypeD","avtactionDoc","avtAPH"],"avtAction_Code")).subscribe(action =>
  //     {
  //       this.exist = true;
  //       window.close();
  //     })
  //   })
  // }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.fenetre = params['fenetre'];
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      this.mode = params['mode'];
      if (!this.generalService.isNotEmpty(this.mode)) this.mode = 'ordinaire';
      else {
        this.Tiers_code = params['Tiers_code'];
        this.indexTabs = parseInt(params['indexTabs']);
        this.modeFacturation = parseInt(params['modeFacuration']);
        this.modePaiement = parseInt(params['modePayement']);
        this.avtAction_Code = params['avtAction_Code'];
        this.tva = parseInt(params['tva']);
      }

      this.init();
    });
  }
}
